import Edit from "./Edit";
import List from "./List";
import UserSearch from "./UserSearch";


export default { Edit, List, UserSearch };
